import { jsx as _jsx } from "react/jsx-runtime";
import { createElement as _createElement } from "react";
import { breakpointValues } from '@modernhealth/vital-foundation';
import Carousel from 'react-slick';
import clsx from 'clsx';
import iconArrowBack from '../assets/icon-arrow-back.svg';
import iconArrowForward from '../assets/icon-arrow-forward.svg';
import * as styles from './ContentCardsRow.module.scss';
import { ContentCard, ContentCardSkeleton, } from '../ContentCard/ContentCard';
const Name = 'ContentCardsRow';
export const ContentCardsRow = ({ items, cardTestID = 'ContentCard', }) => {
    return (_jsx(Carousel, { ...sliderSettings, className: styles.carousel, "data-component": Name, children: items.map((item, i) => (_jsx("div", { className: styles.carouselItem, children: _createElement(ContentCard, { ...item, key: item.id, testID: cardTestID + i }) }, `slide_${item.title}`))) }));
};
export const ContentCardsRowSkeleton = ({ items }) => {
    return (_jsx(Carousel, { ...sliderSettings, className: styles.carousel, arrows: false, children: items.map((_, i) => (_jsx("div", { className: styles.carouselItem, children: _jsx(ContentCardSkeleton, {}) }, `slide_skeleton_${i}`))) }));
};
const CarouselButton = ({ onClick, className = '', prevButton, }) => {
    const xPosField = prevButton ? styles.left : styles.right;
    const imageStyles = clsx([styles.carouselArrowImage, xPosField]);
    const image = prevButton ? iconArrowBack : iconArrowForward;
    const opacity = className.includes('disabled') ? 0 : 1;
    return (_jsx("img", { className: imageStyles, style: { opacity }, src: image, onClick: onClick, alt: "" }));
};
const sliderSettings = {
    infinite: false,
    speed: 500,
    dots: false,
    slidesToShow: 5,
    slidesToScroll: 3,
    nextArrow: _jsx(CarouselButton, {}),
    prevArrow: _jsx(CarouselButton, { prevButton: true }),
    responsive: [
        {
            breakpoint: breakpointValues.md,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 1,
                arrows: false,
            },
        },
        {
            breakpoint: breakpointValues.xl,
            settings: {
                slidesToShow: 4,
                slidesToScroll: 1,
                arrows: false,
            },
        },
    ],
};
